import { userType } from "../type";

const initialState = {
    userList: undefined,
    error: undefined,
    isLoading: false,
    message: undefined
};

const userReducer = (state = initialState, action) => {
    const { type, payload = {} } = action;
    const { data, userId, message } = payload;
    
    switch (type) {
        case userType.GET_ALL_USER:
            return { ...state, userList: data, isLoading: false };
        case userType.ADD_USER:
            return { ...state, userList: [...state.userList, data], isLoading: false };
            case userType.UPDATE_USER:
                return {
                  ...state,
                  userList: state.userList.map((user) =>
                    user._id === payload.userId ? { ...user, ...payload.data } : user
                  ),
                  isLoading: false,
                  message: payload.message || state.message,
                };
              
        case userType.CHANGE_PASSWORD:
            return { ...state, isLoading: false, message };
        case userType.DELETE_USER:
            return { ...state, userList: state.userList.filter((state) => state._id !== userId), isLoading: false, message };
        case userType.MESSAGE:
            return { ...state, isLoading: false, message: payload };
        default:
            return state;
    }
};
export default userReducer;
